/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const ExternalSheetConstraint = core.serialization.object({
    validator: core.serialization.string(),
    fields: core.serialization.list(core.serialization.string()).optional(),
    config: core.serialization.any().optional(),
});
